export default __webpack_public_path__ + "static/media/blog-img54.007b8606.jpg";